import { configureStore } from '@reduxjs/toolkit';
import authSlice from './slices/authSlice';
import recipeSlice from './slices/recipeSlice';
import settingsSlice from './slices/settingsSlice';
import blogSlice from './slices/blogSlice';
import tagSlice from './slices/tagSlice';
import qnaSlice from './slices/qnaSlice';

export const store = configureStore({
    reducer: {
        auth: authSlice,
        recipe: recipeSlice,
        settings: settingsSlice,
        blogs: blogSlice,
        tags: tagSlice,
        qna: qnaSlice,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false
        }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;